import { CommonModule } from '@angular/common';
import { Component, Input, Output } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { Router, RouterModule } from '@angular/router';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from '../../../../material.module';
import { Routes } from "@angular/router";
import { EventEmitter } from '@angular/core';
import { NotesofaccountsComponent } from '../notesofaccounts.component';


@Component({
  selector: 'app-note3',        
  imports: [TablerIconsModule, MaterialModule, CommonModule, RouterModule, MatTabsModule, NotesofaccountsComponent],
  templateUrl: './note3.component.html',
  styleUrl: './note3.component.scss'
})
export class Note3Component {

  constructor(private router: Router, private ParentCoponent: NotesofaccountsComponent) {
  alert('child')
  }
  ngOnInit(): void {
    alert('ngonit')
    this.SaveandNextNote(this.selectedNoteFromParent,false)
  }
  selectNotes: boolean = true; selectedNotes: boolean = false;


  @Output() childClicked = new EventEmitter<string>(); // Emits a string
  @Input() selectedNoteFromParent: string; // This receives data from the parent
  emitClickEvent(CurrentNote:any) {
    this.childClicked.emit(CurrentNote);
  }

  isEditing: boolean = false; note1: boolean = true; note2: boolean = false; note3: boolean = false; note4: boolean = false; note5: boolean = false; note6: boolean = false;
  note7: boolean = false; note8: boolean = false; note9: boolean = false; note10: boolean = false; note11: boolean = false; note12: boolean = false; note13: boolean = false;
  note14: boolean = false; note15: boolean = false; note16: boolean = false; note17: boolean = false;
  FinancialNotes: any[] = [
    { id: 1, title: 'Basis of preparation', required: true, },
    { id: 2, title: 'Accounting policies', required: true },
    { id: 3, title: 'Income Analysis by Category', required: false },
    { id: 4, title: 'Government Grants', required: false },
    { id: 5, title: 'Donated Goods/Services', required: false },
    { id: 6, title: 'Expenditure Analysis', required: false },
    { id: 7, title: 'Extraordinary Items', required: false },
    { id: 8, title: 'Acting as Agent', required: false },
    { id: 9, title: 'Support Costs Allocation', required: false },
    { id: 10, title: 'Independent Examiner/Audit Fees', required: false },
    { id: 11, title: 'Staff Costs & Employee Information', required: false },
    { id: 12, title: 'Pension Disclosures', required: false },
    { id: 13, title: 'Grantmaking Details', required: false },
    { id: 14, title: 'Tangible Fixed Assets', required: false },
    { id: 15, title: 'Intangible Assets', required: false },
    { id: 16, title: 'Heritage Assets', required: false },
    { id: 17, title: 'Investment Assets', required: false },
    { id: 18, title: 'Stocks', required: false },
    { id: 19, title: 'Debtors & Prepayments', required: false },
    { id: 20, title: 'Creditors & Accruals', required: false },
    { id: 21, title: 'Provisions & Contingent Liabilities', required: false },
    { id: 22, title: 'Financial Instruments', required: false },
    { id: 23, title: 'Contingent Assets & Liabilities', required: false },
    { id: 24, title: 'Cash at Bank and in Hand', required: false },
    { id: 25, title: 'Fair Value Disclosures', required: false },
    { id: 26, title: 'Post-Balance Sheet Events', required: false },
    { id: 27, title: 'Fund Movements & Reconciliation', required: false },
    { id: 28, title: 'Trustee & Related Party Transactions', required: false },
    { id: 29, title: 'Other Disclosures (custom/free-form)', required: false }
  ];

  textContent: string = "The financial statements have been prepared in accordance with Accounting and Reporting by Charities: Statement of Recommended Practice applicable to charities preparing their accounts in accordance with the Financial Reporting Standard applicable in the UK and Republic of Ireland (FRS 102) (effective 1 January 2019) - (Charities SORP (FRS 102)), the Financial Reporting Standard applicable in the UK and Republic of Ireland (FRS 102) and the Companies Act 2006.";

  isChecked = false; isChecked2 = false; isChecked3 = false; isChecked4 = false; isChecked5 = false; isChecked6 = false; isChecked7 = false; isChecked8 = false;
  isActive: boolean = false; isActive2: boolean = false; isActive3: boolean = false; isActive4: boolean = false; isActive5: boolean = false; isActive6: boolean = false;
  isActive7: boolean = false; isActive8: boolean = false; isActive9: boolean = false; isActive10: boolean = false; isActive11: boolean = false; isActive12: boolean = false;
  isActive13: boolean = false; isActive14: boolean = false; isActive15: boolean = false; isActive16: boolean = false; isActive17: boolean = false;
  CurrentNote: string;
  CurrentNoteisactive: string;

  toggleEdit() {
    this.isEditing = !this.isEditing;
  }

  backToSelectNotes() {
    this.selectNotes = true;
    this.selectedNotes = false;
  }


  displayedColumns: string[] = ['Fund balances as previously stated', 'Start of period', 'End of period'];
  data: any[] = [
    { type: 'data', Description: 'Turnover', IncomeExpenses: '', Disallowable: '' },
  ];

  displayedColumns2: string[] = ['Net income/(expenditure) as previously stated', 'End of period'];
  data2: any[] = [
    { type: 'data', Description: 'Turnover', IncomeExpenses: '', Disallowable: '' },
  ];

  displayedColumns3: string[] = ['Name', 'Rate', 'Action'];
  assetsTangible: any[] = [
    { name: 'data', rate: '20' },
  ];

  displayedColumns4: string[] = ['Name', 'Rate', 'Action'];
  assetsInTangible: any[] = [
    { type: 'data', Description: 'Turnover', IncomeExpenses: '', Disallowable: '' },
  ];

  displayedColumnsDonations: string[] = ['Analysis', 'Unrestricted', 'Restricted', 'Endowment', 'Total', 'Prior year'];
  donations: any[] = [
    { type: 'General grants provided by government / other charities' },
    { type: 'Donations and gifts - General' },
    { type: 'Gift Aid' },
    { type: 'Donations and gifts - Covid 19 Specific' },
    { type: 'Legacies' },
    { type: 'Membership subscriptions and sponsorships which are in substance donations' },
    { type: 'Donated goods, facilities and services' },
    { type: 'Other' },
  ];

  displayedColumnsCharitable: string[] = ['Analysis', 'Unrestricted', 'Restricted', 'Endowment', 'Total', 'Prior year'];
  Charitable: any[] = [
    { type: 'General grants provided by government / other charities' },
  ];

  displayedColumnsOtherCharitable: string[] = ['Analysis', 'Unrestricted', 'Restricted', 'Endowment', 'Total', 'Prior year'];
  OtherCharitable: any[] = [
    { type: 'General grants provided by government / other charities' },
  ];

  displayedColumnsInvestment: string[] = ['Analysis', 'Unrestricted', 'Restricted', 'Endowment', 'Total', 'Prior year'];
  Investment: any[] = [
    { type: 'Interest income' },
    { type: 'Dividend income' },
    { type: 'Rent and leasing income' },
    { type: 'Other' },
  ];

  displayedColumnsmaterial: string[] = ['Analysis', 'Unrestricted', 'Restricted', 'Endowment', 'Total', 'Prior year'];
  material: any[] = [
    { type: 'General grants provided by government / other charities' },
  ];

  changetoNoteTab1() {
    this.note1 = true;
    this.note2 = false;
    this.note3 = false;
    this.note4 = false;
    this.note5 = false;
    this.note6 = false;
    this.note7 = false;
    this.note8 = false;
    this.note9 = false;
    this.note10 = false;
    this.note11 = false;
    this.note12 = false;
    this.note13 = false;
    this.note14 = false;
    this.note15 = false;
    this.isActive = true;
    this.isActive2 = false;
    this.isActive3 = false;
    this.isActive4 = false;
    this.isActive5 = false;
    this.isActive6 = false;
    this.isActive7 = false;
    this.isActive8 = false;
    this.isActive9 = false;
    this.isActive10 = false;
    this.isActive11 = false;
    this.isActive12 = false;
    this.isActive13 = false;
    this.isActive14 = false;
    this.isActive15 = false;
  }
  changetoNoteTab2() {
    this.note1 = false;
    this.note2 = true;
    this.note3 = false;
    this.note4 = false;
    this.note5 = false;
    this.note6 = false;
    this.note7 = false;
    this.note8 = false;
    this.note9 = false;
    this.note10 = false;
    this.note11 = false;
    this.note12 = false;
    this.note13 = false;
    this.note14 = false;
    this.note15 = false;
    this.isActive = false;
    this.isActive2 = true;
    this.isActive3 = false;
    this.isActive4 = false;
    this.isActive5 = false;
    this.isActive6 = false;
    this.isActive7 = false;
    this.isActive8 = false;
    this.isActive9 = false;
    this.isActive10 = false;
    this.isActive11 = false;
    this.isActive12 = false;
    this.isActive13 = false;
    this.isActive14 = false;
    this.isActive15 = false;
  }
  changetoNoteTab3() {
    this.note1 = false;
    this.note2 = false;
    this.note3 = true;
    this.note4 = false;
    this.note5 = false;
    this.note6 = false;
    this.note7 = false;
    this.note8 = false;
    this.note9 = false;
    this.note10 = false;
    this.note11 = false;
    this.note12 = false;
    this.note13 = false;
    this.note14 = false;
    this.note15 = false;
    this.isActive = false;
    this.isActive2 = false;
    this.isActive3 = true;
    this.isActive4 = false;
    this.isActive5 = false;
    this.isActive6 = false;
    this.isActive7 = false;
    this.isActive8 = false;
    this.isActive9 = false;
    this.isActive10 = false;
    this.isActive11 = false;
    this.isActive12 = false;
    this.isActive13 = false;
    this.isActive14 = false;
    this.isActive15 = false;
  }
  changetoNoteTab4() {
    this.note1 = false;
    this.note2 = false;
    this.note3 = false;
    this.note4 = true;
    this.note5 = false;
    this.note6 = false;
    this.note7 = false;
    this.note8 = false;
    this.note9 = false;
    this.note10 = false;
    this.note11 = false;
    this.note12 = false;
    this.note13 = false;
    this.note14 = false;
    this.note15 = false;
    this.isActive = false;
    this.isActive2 = false;
    this.isActive3 = false;
    this.isActive4 = true;
    this.isActive5 = false;
    this.isActive6 = false;
    this.isActive7 = false;
    this.isActive8 = false;
    this.isActive9 = false;
    this.isActive10 = false;
    this.isActive11 = false;
    this.isActive12 = false;
    this.isActive13 = false;
    this.isActive14 = false;
    this.isActive15 = false;
  }
  changetoNoteTab5() {
    this.note1 = false;
    this.note2 = false;
    this.note3 = false;
    this.note4 = false;
    this.note5 = true;
    this.note6 = false;
    this.note7 = false;
    this.note8 = false;
    this.note9 = false;
    this.note10 = false;
    this.note11 = false;
    this.note12 = false;
    this.note13 = false;
    this.note14 = false;
    this.note15 = false;
    this.isActive = false;
    this.isActive2 = false;
    this.isActive3 = false;
    this.isActive4 = false;
    this.isActive5 = true;
    this.isActive6 = false;
    this.isActive7 = false;
    this.isActive8 = false;
    this.isActive9 = false;
    this.isActive10 = false;
    this.isActive11 = false;
    this.isActive12 = false;
    this.isActive13 = false;
    this.isActive14 = false;
    this.isActive15 = false;
  }
  changetoNoteTab6() {
    this.note1 = false;
    this.note2 = false;
    this.note3 = false;
    this.note4 = false;
    this.note5 = false;
    this.note6 = true;
    this.note7 = false;
    this.note8 = false;
    this.note9 = false;
    this.note10 = false;
    this.note11 = false;
    this.note12 = false;
    this.note13 = false;
    this.note14 = false;
    this.note15 = false;
    this.isActive = false;
    this.isActive2 = false;
    this.isActive3 = false;
    this.isActive4 = false;
    this.isActive5 = false;
    this.isActive6 = true;
    this.isActive7 = false;
    this.isActive8 = false;
    this.isActive9 = false;
    this.isActive10 = false;
    this.isActive11 = false;
    this.isActive12 = false;
    this.isActive13 = false;
    this.isActive14 = false;
    this.isActive15 = false;
  }
  changetoNoteTab7() {
    this.note1 = false;
    this.note2 = false;
    this.note3 = false;
    this.note4 = false;
    this.note5 = false;
    this.note6 = false;
    this.note7 = true;
    this.note8 = false;
    this.note9 = false;
    this.note10 = false;
    this.note11 = false;
    this.note12 = false;
    this.note13 = false;
    this.note14 = false;
    this.note15 = false;
    this.isActive = false;
    this.isActive2 = false;
    this.isActive3 = false;
    this.isActive4 = false;
    this.isActive5 = false;
    this.isActive6 = false;
    this.isActive7 = true;
    this.isActive8 = false;
    this.isActive9 = false;
    this.isActive10 = false;
    this.isActive11 = false;
    this.isActive12 = false;
    this.isActive13 = false;
    this.isActive14 = false;
    this.isActive15 = false;
  }
  BackNote() {
    debugger
    var currentNoteNumber
    var currentNoteisactive = null
    var NextNoteisactive = null
    var NextNoteNumvber = ''
    currentNoteNumber = this.CurrentNote.split('note')[1]
    currentNoteisactive = this.CurrentNoteisactive.split('isActive')[1]

    NextNoteisactive = `isActive${+currentNoteisactive - 1}`
    NextNoteNumvber = `note${+currentNoteNumber - 1}`
    this.ClickSelectedNote(NextNoteNumvber, NextNoteisactive)
    this.ParentCoponent.ChangeIsActiveFromChild(NextNoteisactive)
   }
  SaveandNextNote(note?:any,IsNextClick?:any) {
    debugger

    var currentNoteNumber
    var currentNoteisactive = null
    var NextNoteisactive = null
    var NextNoteNumvber=''
    if (IsNextClick == false) {
      var Parentnote = this.selectedNoteFromParent.split('/')
      currentNoteNumber = Parentnote[0].split('note')[1]
      currentNoteisactive = Parentnote[1].split('isActive')[1]    
      NextNoteNumvber = `note${+currentNoteNumber}`
    
      this.CurrentNote = NextNoteNumvber
      NextNoteisactive = `isActive${+currentNoteisactive}`
    }
    else {

      currentNoteNumber = this.CurrentNote ? this.CurrentNote.split('note')[1] : note.split('note')[1]
      currentNoteisactive = this.CurrentNoteisactive.split('isActive')[1]

      NextNoteisactive = `isActive${+currentNoteisactive + 1}`
      NextNoteNumvber = `note${+currentNoteNumber + 1}`
    }        
    this.ClickSelectedNote(NextNoteNumvber, NextNoteisactive)
    this.ParentCoponent.ChangeIsActiveFromChild(NextNoteisactive)
    
  }


  changetoNoteTab8() {
    this.note1 = false;
    this.note2 = false;
    this.note3 = false;
    this.note4 = false;
    this.note5 = false;
    this.note6 = false;
    this.note7 = false;
    this.note8 = true;
    this.note9 = false;
    this.note10 = false;
    this.note11 = false;
    this.note12 = false;
    this.note13 = false;
    this.note14 = false;
    this.note15 = false;
    this.isActive = false;
    this.isActive2 = false;
    this.isActive3 = false;
    this.isActive4 = false;
    this.isActive5 = false;
    this.isActive6 = false;
    this.isActive7 = false;
    this.isActive8 = true;
    this.isActive9 = false;
    this.isActive10 = false;
    this.isActive11 = false;
    this.isActive12 = false;
    this.isActive13 = false;
    this.isActive14 = false;
    this.isActive15 = false;
  }
  changetoNoteTab9() {
    this.note1 = false;
    this.note2 = false;
    this.note3 = false;
    this.note4 = false;
    this.note5 = false;
    this.note6 = false;
    this.note7 = false;
    this.note8 = false;
    this.note9 = true;
    this.note10 = false;
    this.note11 = false;
    this.note12 = false;
    this.note13 = false;
    this.note14 = false;
    this.note15 = false;
    this.isActive = false;
    this.isActive2 = false;
    this.isActive3 = false;
    this.isActive4 = false;
    this.isActive5 = false;
    this.isActive6 = false;
    this.isActive7 = false;
    this.isActive8 = false;
    this.isActive9 = true;
    this.isActive10 = false;
    this.isActive11 = false;
    this.isActive12 = false;
    this.isActive13 = false;
    this.isActive14 = false;
    this.isActive15 = false;
  }
  changetoNoteTab10() {
    this.note1 = false;
    this.note2 = false;
    this.note3 = false;
    this.note4 = false;
    this.note5 = false;
    this.note6 = false;
    this.note7 = false;
    this.note8 = false;
    this.note9 = false;
    this.note10 = true;
    this.note11 = false;
    this.note12 = false;
    this.note13 = false;
    this.note14 = false;
    this.note15 = false;
    this.isActive = false;
    this.isActive2 = false;
    this.isActive3 = false;
    this.isActive4 = false;
    this.isActive5 = false;
    this.isActive6 = false;
    this.isActive7 = false;
    this.isActive8 = false;
    this.isActive9 = false;
    this.isActive10 = true;
    this.isActive11 = false;
    this.isActive12 = false;
    this.isActive13 = false;
    this.isActive14 = false;
    this.isActive15 = false;
  }
  changetoNoteTab11() {
    this.note1 = false;
    this.note2 = false;
    this.note3 = false;
    this.note4 = false;
    this.note5 = false;
    this.note6 = false;
    this.note7 = false;
    this.note8 = false;
    this.note9 = false;
    this.note10 = false;
    this.note11 = true;
    this.note12 = false;
    this.note13 = false;
    this.note14 = false;
    this.note15 = false;
    this.isActive = false;
    this.isActive2 = false;
    this.isActive3 = false;
    this.isActive4 = false;
    this.isActive5 = false;
    this.isActive6 = false;
    this.isActive7 = false;
    this.isActive8 = false;
    this.isActive9 = false;
    this.isActive10 = false;
    this.isActive11 = true;
    this.isActive12 = false;
    this.isActive13 = false;
    this.isActive14 = false;
    this.isActive15 = false;
  }
  changetoNoteTab12() {
    this.note1 = false;
    this.note2 = false;
    this.note3 = false;
    this.note4 = false;
    this.note5 = false;
    this.note6 = false;
    this.note7 = false;
    this.note8 = false;
    this.note9 = false;
    this.note10 = false;
    this.note11 = false;
    this.note12 = true;
    this.note13 = false;
    this.note14 = false;
    this.note15 = false;
    this.isActive = false;
    this.isActive2 = false;
    this.isActive3 = false;
    this.isActive4 = false;
    this.isActive5 = false;
    this.isActive6 = false;
    this.isActive7 = false;
    this.isActive8 = false;
    this.isActive9 = false;
    this.isActive10 = false;
    this.isActive11 = false;
    this.isActive12 = true;
    this.isActive13 = false;
    this.isActive14 = false;
    this.isActive15 = false;
  }
  changetoNoteTab13() {
    this.note1 = false;
    this.note2 = false;
    this.note3 = false;
    this.note4 = false;
    this.note5 = false;
    this.note6 = false;
    this.note7 = false;
    this.note8 = false;
    this.note9 = false;
    this.note10 = false;
    this.note11 = false;
    this.note12 = false;
    this.note13 = true;
    this.note14 = false;
    this.note15 = false;
    this.isActive = false;
    this.isActive2 = false;
    this.isActive3 = false;
    this.isActive4 = false;
    this.isActive5 = false;
    this.isActive6 = false;
    this.isActive7 = false;
    this.isActive8 = false;
    this.isActive9 = false;
    this.isActive10 = false;
    this.isActive11 = false;
    this.isActive12 = false;
    this.isActive13 = true;
    this.isActive14 = false;
    this.isActive15 = false;
  }
  ClickSelectedNote(note: string,IsActive?:any): void {
    debugger
    this.note1 = false;
    this.note2 = false;
    this.note3 = false;
    this.note4 = false;
    this.note5 = false;
    this.note6 = false;
    this.note7 = false;
    this.note8 = false;
    this.note9 = false;
    this.note10 = false;
    this.note11 = false;
    this.note12 = false;
    this.note13 = false;
    this.note14 = false;
    this.note15 = false;
    this.note16 = false;
    this.note17 = false;
    this.isActive = false;
    this.isActive2 = false;
    this.isActive3 = false;
    this.isActive4 = false;
    this.isActive5 = false;
    this.isActive6 = false;
    this.isActive7 = false;
    this.isActive8 = false;
    this.isActive9 = false;
    this.isActive10 = false;
    this.isActive11 = false;
    this.isActive12 = false;
    this.isActive13 = false;
    this.isActive14 = false;
    this.isActive15 = false;
    this.isActive16 = false;
    this.isActive17 = false;
    (this as any)[note] = true;
   
   // this.emitClickEvent(this.CurrentNote)
    this.CurrentNoteisactive = IsActive
    this.CurrentNote = note

    
  }
  SaveAndNext() {
    debugger
    var currentNoteNumber = this.CurrentNote.split('note')[1]
   // var currentNoteisactive = this.CurrentNoteisactive.split('isActive')[1]
    var NextNoteNumvber = `note${+currentNoteNumber + 1}`
   // var NextNoteisactive = `isActive${+currentNoteisactive + 1}`
 //   this.ClickSelectedNote(NextNoteNumvber, NextNoteisactive)
   // this.router.navigate([''])
  }
  changetoNoteTab14() {
    this.note1 = false;
    this.note2 = false;
    this.note3 = false;
    this.note4 = false;
    this.note5 = false;
    this.note6 = false;
    this.note7 = false;
    this.note8 = false;
    this.note9 = false;
    this.note10 = false;
    this.note11 = false;
    this.note12 = false;
    this.note13 = false;
    this.note14 = true;
    this.note15 = false;
    this.isActive = false;
    this.isActive2 = false;
    this.isActive3 = false;
    this.isActive4 = false;
    this.isActive5 = false;
    this.isActive6 = false;
    this.isActive7 = false;
    this.isActive8 = false;
    this.isActive9 = false;
    this.isActive10 = false;
    this.isActive11 = false;
    this.isActive12 = false;
    this.isActive13 = false;
    this.isActive14 = true;
    this.isActive15 = false;
  }
  changetoNoteTab15() {
    this.note1 = false;
    this.note2 = false;
    this.note3 = false;
    this.note4 = false;
    this.note5 = false;
    this.note6 = false;
    this.note7 = false;
    this.note8 = false;
    this.note9 = false;
    this.note10 = false;
    this.note11 = false;
    this.note12 = false;
    this.note13 = false;
    this.note14 = false;
    this.note15 = true;
    this.isActive = false;
    this.isActive2 = false;
    this.isActive3 = false;
    this.isActive4 = false;
    this.isActive5 = false;
    this.isActive6 = false;
    this.isActive7 = false;
    this.isActive8 = false;
    this.isActive9 = false;
    this.isActive10 = false;
    this.isActive11 = false;
    this.isActive12 = false;
    this.isActive13 = false;
    this.isActive14 = false;
    this.isActive15 = true;
  }
}
